import { BadgeTemplatePreview } from '../../../../ui/features/badge-preview/components/BadgeTemplatePreview';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const BadgeTemplateTwoSidePreview = ({ badgeTemplateClassifier, formSettings, account, badgeTemplateFront, badgeTemplateBack, }) => {
    const { t } = useBadgingTranslation();
    return (React.createElement(Box, { className: 'BadgeTemplateTwoSidePreview', sx: {
            backgroundColor: themeColors.surface.secondary,
            borderRadius: 1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            p: 3,
            overflowY: 'auto',
        } },
        React.createElement(Typography, { variant: 'subtitle1', mb: 3 }, t('badgePreview.preview')),
        React.createElement(Box, { sx: {
                display: 'flex',
                gap: { xs: 2, md: 3 },
                px: { md: 3 },
                flex: 1,
                alignItems: 'center',
                maxWidth: { md: '75vh' },
                alignSelf: 'center',
                width: '100%',
            } },
            React.createElement(Box, { sx: {
                    flexBasis: '50%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    alignItems: 'center',
                } },
                React.createElement(BadgeTemplatePreview, { badgeTemplateClassifier: badgeTemplateClassifier, badgeTemplate: badgeTemplateFront, formSettings: formSettings, account: account, sx: {
                        width: '100%',
                        display: 'flex',
                        borderStyle: 'solid',
                        borderWidth: 2,
                        borderColor: themeColors.border.main,
                        borderRadius: 1,
                    } }),
                React.createElement(Typography, { variant: 'subtitle2' }, t('badgePreview.front'))),
            React.createElement(Box, { sx: {
                    flexBasis: '50%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    alignItems: 'center',
                } },
                React.createElement(BadgeTemplatePreview, { badgeTemplateClassifier: badgeTemplateClassifier, badgeTemplate: badgeTemplateBack, formSettings: formSettings, account: account, sx: {
                        width: '100%',
                        display: 'flex',
                        borderStyle: 'solid',
                        borderWidth: 2,
                        borderColor: themeColors.border.main,
                        borderRadius: 1,
                    } }),
                React.createElement(Typography, { variant: 'subtitle2' }, t('badgePreview.back'))))));
};
